import AppSettings from '../AppSettings';
import IConfigurationPageQuery from '../configurator/IConfigurationPageQuery';
import { ShoppingContext, StoreContext } from '../data/model';
import { StoreUrl } from './StoreUrl';

export interface IPdfUrlProvider {
  initialize(shoppingContext: ShoppingContext, storeContext: StoreContext): void;
  getPdfUrl(slug: string, configurationQuery: IConfigurationPageQuery): string;
}

export abstract class BasePdfOriginProvider implements IPdfUrlProvider {
  private storeId?: string;
  private languageCode?: string;

  protected constructor(protected readonly settings: AppSettings) {}

  initialize(shoppingContext: ShoppingContext, storeContext: StoreContext): void {
    const { storeId, languageCode } = this.getStoreAndLanguage(shoppingContext, storeContext);
    this.storeId = storeId;
    this.languageCode = languageCode;
  }

  getPdfUrl(slug: string, configurationQuery: IConfigurationPageQuery): string {
    if (!this.storeId || !this.languageCode) {
      throw new Error(`This instance of PDF URL provider is not initialized`);
    }

    const relativeUrl = StoreUrl.productPdfPrintUrl(this.storeId, this.languageCode, slug, configurationQuery);
    return `${this.origin}${relativeUrl.toString()}`;
  }

  protected abstract getStoreAndLanguage(
    shoppingContext: ShoppingContext,
    storeContext: StoreContext,
  ): { storeId: string; languageCode: string };

  protected abstract get origin(): string;
}

export class DefaultPdfOriginProvider extends BasePdfOriginProvider {
  constructor(settings: AppSettings) {
    super(settings);
  }

  protected getStoreAndLanguage(
    shoppingContext: ShoppingContext,
    _: StoreContext,
  ): { storeId: string; languageCode: string } {
    return { storeId: shoppingContext.storeId, languageCode: shoppingContext.languageCode };
  }

  protected get origin(): string {
    return this.settings.baseUrl;
  }
}
